/*
 *   File : sip-dates.js
 *   Author : https://evoqins.com
 *   Description : SIP date modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useEffect, useRef, useState } from "react";

// Component
import { Toast } from '../note';

import style from '../../styles/components/rebalance.module.scss';

import devconfig from '../../config/config';
import APIPost from '../../services/postApi';
import SelectBox from "../dropdown/selectBox";
import { Input } from "../input";
import { PrimaryBtn, SecondaryBtn } from "../cta";
import { useNavigate } from "react-router-dom";
import { message } from "antd";

const actionOptions = [
    {
        label: "No Action Required",
        value: null
    },
    {
        label: "Redeem",
        value: "REDEMPTION"
    },
    {
        label: "Invest More",
        value: "PURCHASE"
    },
    {
        label: "Switch",
        value: "SWITCH"
    },
    // {
    //     label: "New Purchase",
    //     value: "NEW_PURCHASE"
    // },
    {
        label: "Switch All",
        value: "SWITCH_ALL"
    },
    {
        label: "Redeem All",
        value: "REDEEM_ALL"
    }
]


const MiniRebalance = React.memo((props) => {

    const searchRef = useRef([]);
    const navigate = useNavigate();
    let typingTimer;


    const [toastMessage, setToastMessage] = useState(null);

    const [selectedFunds, setSelectedFunds] = useState(props.data.funds.map((item, index) => ({
        type: actionOptions[0],
        amount: "",
        index: index,
        switch_in_mf_id: null,
        switch_name: "",
        purchase_fund: "",
        purchase_scheme: null,
        ...item
    })))
    const [showDropdown, setShowDropdown] = useState(false);
    const [fundsList, setFundsList] = useState([]);
    const [apiLoader, setApiLoader] = useState(false);
    const [orderSent, setOrderSent] = useState(false);
    const [hasPending, setHasPending] = useState(false);
    const [pendingDetails, setPendingDetails] = useState([]);


    useEffect(() => {
        document.addEventListener('mouseup', _closeMenu);
        return () => {
            document.removeEventListener('mouseup', _closeMenu);
        };
    }, []);

    useEffect(() => {
        var my_modal = document.getElementById("mini-rebalance");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.handleCloseModal();
        });
        //eslint-disable-next-line
    }, [props.handleCloseModal]);

    // useEffect(() => {
    //     if (toastMessage !== null) {
    //         setTimeout(() => {
    //             setToastMessage(null);
    //         }, 4000);
    //     }
    // }, [toastMessage])

    useEffect(() => {
        const checkPending = async () => {
            const url = devconfig.admin + '/rebalance/has-pending-rebalance';
            const payload = JSON.stringify({
                customer_id: Number(props.id),
                goal_id: props.data.goal_id,
                goal_type: props.data.goal_type || false,
                is_sip_rebalnce: false
            });
            const response = await APIPost(url, payload);
            if (response.status_code === 200) {
                const data = Array.isArray(response.data) ? response.data : [response.data];
                const pendingItems = data.filter(item => item?.has_pending_rebalance);
                setHasPending(pendingItems.length > 0);
                setPendingDetails(pendingItems);
            }
        };
        checkPending();
    }, [props.id, props.data.goal_id]);

    const _handleCloseModal = () => {
        document.getElementById("close-mr").dispatchEvent(new Event("click"));
    };

    const _closeMenu = (event) => {
        if (
            searchRef.current[showDropdown] &&
            !searchRef.current[showDropdown].contains(event.target)
        ) {
            setShowDropdown(false);
        }
    }

    function _handleFundSelect(value, index, switch_id) {
        const funds = [...selectedFunds]
        funds[index].switch_name = value;
        funds[index].switch_in_mf_id = switch_id;

        setSelectedFunds(funds)
    }

    function _handleFundPurchase(value, index, switch_id) {
        const funds = [...selectedFunds]
        funds[index].purchase_fund = value;
        funds[index].purchase_scheme = switch_id;

        setSelectedFunds(funds)
    }

    function _handleAddNew() {
        const list = [...selectedFunds]
        const newItem = {
            type: {
                label: "New Purchase",
                value: "NEW_PURCHASE"
            },
            amount: "",
            switch_in_mf_id: null,
            switch_name: "",
            purchase_fund: "",
            purchase_scheme: null,
            index: selectedFunds.length
        }
        list.push(newItem)
        setSelectedFunds(list)
        setTimeout(() => {
            const container = document.getElementById("e-funds");
            if (container) {
                container.scrollTo({
                    top: container.scrollHeight + 1000,
                    behavior: "smooth", // smooth scroll
                });
            }
        }, 20);
    }


    function _handleDeleteAddedFund(index, actualIndex) {
        // let deleteIndex = selectedFunds.filter(fund => fund.index !== actualIndex);
        // console.log(deleteIndex)
        const selected_funds = [...selectedFunds]
        selected_funds.splice(index, 1);
        setSelectedFunds(selected_funds);
    }


    function _handleAction(selected, index, obj) {
        let funds = [...selectedFunds]
        funds[index].type = selected;
        funds[index].amount = (selected?.value === "SWITCH_ALL" || selected?.value === "REDEEM_ALL") ? parseFloat(funds[index].invested_amount) : "";
        funds[index].switch_in_mf_id = null;
        funds[index].switch_name = "";
        funds = funds.filter((f, i) => {
            if (i === index) return true; // keep the current one
            return f.index !== funds[index].index; // remove any other with same index
        });
        setSelectedFunds(funds)
    }


    function _handleAmount(value, index) {
        const funds = [...selectedFunds]
        funds[index].amount = parseFloat(value);
        setSelectedFunds(funds)
    }

    function _handleAddSwitchInFund(index) {
        setSelectedFunds((prev) => {
            const newFunds = [...prev];
            const currentFund = newFunds[index];

            // Create a copy of the current fund but reset switch-related fields
            const newFund = {
                ...currentFund,
                amount: "",
                switch_in_mf_id: null,
                switch_name: "",
                purchase_fund: "",
                purchase_scheme: null,
                index: index
            };

            // Insert new fund just after the current index
            newFunds.splice(index + 1, 0, newFund);
            return newFunds;
        });

    }

    function _handleDeleteSwitchInFund(index) {
        setSelectedFunds((prev) => {
            const newFunds = [...prev];
            newFunds.splice(index, 1); // remove the clicked fund
            return newFunds;
        });
    }


    // API - fund list
    const _getFunds = (query = null, index) => {
        let api_url = devconfig.admin + '/fund/v2/search';
        let sample_query = query.length > 0 ? query.replace(/\s*-\s*/g, " ") : ""
        let data = JSON.stringify({
            query: sample_query.toLowerCase().trim(),
            page_num: 1,
        });
        APIPost(api_url, data).then((response) => {
            if (response.status_code === 200) {
                setShowDropdown(index);
                setFundsList(response.data);
            } else {
                setToastMessage({ type: 'error', message: response.message });
                setShowDropdown(null);
                setFundsList([]);
            }
        });
    }

    function _viewOrders() {
        navigate("/orders");
        setOrderSent(false);
    }

    function _handleClose() {
        setOrderSent(false);
        props.updateOrder()
    }

    // API - fund detail
    const _getFundDetail = (fund, index) => {
        let api_url = devconfig.admin + '/fund/custom-fund';
        let data = JSON.stringify({
            isin: fund.isin
        });
        APIPost(api_url, data).then((response) => {
            if (response.status_code === 200) {
                _handleFundSelect(fund.scheme_name, index, fund.scheme_code)
                setShowDropdown(false);
            } else {
                _handleFundSelect("", index, null)
                setToastMessage({ type: 'error', message: response.message });
            }
        });
    }

    const _handleMiniRebalance = () => {
        setApiLoader(true);
        const url = devconfig.admin + '/rebalance/goal';
        const rebalance_data = selectedFunds.filter((item) => item.type.value !== null).map((fund) => ({
            "mf_id": fund.type?.value === "NEW_PURCHASE" ? null : fund.mf_id,
            "purchase_scheme": fund.type?.value === "NEW_PURCHASE" ? fund.purchase_scheme : null,
            "amount": fund.amount,
            "type": fund.type?.value === "SWITCH_ALL" ? "SWITCH" : fund.type?.value === "REDEEM_ALL" ? "REDEMPTION" : fund.type?.value,
            "switch_in_mf_id": fund.switch_in_mf_id
        }))
        let payload = JSON.stringify({
            "goal_id": props.data.goal_id,
            "goal_type": props.data.goal_type,
            "customer_id": props.id,
            "rebalance_data": rebalance_data
        }
        );
        APIPost(url, payload).then((response) => {
            if (response.status_code === 200) {
                // _handleCloseModal();
                setOrderSent(true);
            } else {
                setToastMessage({ type: 'error', message: response.message });
            }
            setApiLoader(false);
        })
    }

    const hasRedemption = selectedFunds.some(
        (fund) =>
            fund.type?.value === "REDEMPTION" || fund.type?.value === "REDEEM_ALL"
    );

    function _getTotalAmount() {
        return selectedFunds.reduce((sum, item) => {
            const amount = parseFloat(String(item.amount || '').replace(/[^0-9.-]/g, '')) || 0;
            const type = item.type?.value?.toUpperCase();

            if (type === "REDEEM" || type === "REDEEM_ALL" || type === "REDEMPTION" || type === "REDEM_ALL") {
                return sum - amount; // Treat redemption as negative
            } else if (type === "NEW_PURCHASE" || type === "PURCHASE") {
                return sum + amount; // Treat purchase as positive
            }

            return sum; // Ignore other types like SWITCH
        }, 0);
    }


    // function _getTotalAmount() {
    //     const currentValueStr = props.data?.current_value || "0";
    //     const currentTotal = parseFloat(currentValueStr.replace(/[^0-9.-]/g, '')) || 0;

    //     let delta = 0;

    //     selectedFunds.forEach(item => {
    //         const amount = parseFloat(
    //             String(item.amount || '').replace(/[^0-9.-]/g, '')
    //         ) || 0;
    //         const type = item.type?.value;

    //         if (type === "SWITCH" || type === "SWITCH_ALL") return;

    //         if (type === "REDEMPTION" || type === "REDEM_ALL") {
    //             delta -= amount;
    //         } else if (type === "NEW_PURCHASE") {
    //             delta += amount;
    //         }
    //     });

    //     const total = currentTotal + delta;
    //     return Number(total.toFixed(2));
    // }

    function _validateForm() {
        let isValid = false;

        for (let i = 0; i < selectedFunds.length; i++) {
            const fund = selectedFunds[i];

            if (fund.type && fund.type.value) {
                isValid = true;
            }


            // 1. If type exists, amount must not be empty
            if (fund.type?.value && (!fund.amount || fund.amount.toString().trim() === "")) {
                isValid = false;
                break;
            }

            // 2. If type is SWITCH or SWITCH_ALL → switch_in_mf_id required
            if (
                (fund.type?.value === "SWITCH_ALL" || fund.type?.value === "SWITCH") &&
                fund.switch_in_mf_id === null
            ) {
                isValid = false;
                break;
            }

            // 3. If type is NEW_PURCHASE → purchase_scheme required
            if (fund.type?.value === "NEW_PURCHASE" && fund.purchase_scheme === null) {
                isValid = false;
                break;
            }
        }
        return isValid
    }
    return (
        <>


            <div className={`modal fade ${style.e_rebalance}`}
                id="mini-rebalance"
                tabIndex="-1"
                aria-labelledby="mini-rebalance"
                aria-hidden="true"
                data-bs-keyboard="false">
                {orderSent === true ?
                    <div className={`${style.e_modal_dialog} modal-dialog modal-dialog-centered`}>
                        <div className="modal-content">
                            <img src={require("../../assets/images/modal/successs.png").default}
                                alt="success"
                                width={62}
                                height={62}
                                className='mx-auto mt-1' />
                            <h6 className='pt-4 mt-3 mb-4 pb-2 text-center'>{props.message ?? "Successfully sent to user"}</h6>
                            <div className="row pb-1">
                                <div className="col-lg-12">
                                    <div className="d-flex justify-content-center gap-3">
                                        <SecondaryBtn
                                            name="View orders"
                                            className='e-modal-submit'
                                            cancel="modal"
                                            handleClick={_viewOrders} />
                                        <SecondaryBtn
                                            name="Close"
                                            className={`${style.e_cancel} e-cancel`}
                                            cancel="modal"
                                            handleClick={_handleClose} />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div >
                    :
                    <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>
                        <div className={`modal-content ${style.e_content}`}>
                            <div className="d-flex justify-content-between align-items-center">
                                <h6 className={`${style.e_title} mb-0`}>{"Rebalance"}</h6>
                                <button type="button" id="close-mr" className="btn-close" data-bs-dismiss="modal" aria-label="Close"
                                    style={{ width: "8px", height: "8px" }}
                                    onClick={() => _handleCloseModal()}></button>
                            </div>

                            {hasPending && pendingDetails.length > 0 && (
                                <div className="alert alert-warning mb-3 py-3 px-3">
                                    <strong style={{ fontSize: '15px' }}>There is already a rebalance request pending approval.</strong>
                                    {pendingDetails.map((item, index) => (
                                        <div key={index} className="mt-3" style={{ fontSize: '13px', lineHeight: '1.8' }}>
                                            <div><strong>Order Type:</strong> Rebalance</div>
                                            {item.basket_name && <div><strong>Basket Name:</strong> {item.basket_name}</div>}
                                            {item.order_date && <div><strong>Order Date:</strong> {item.order_date}</div>}
                                        </div>
                                    ))}
                                </div>
                            )}

                            {/* <div className='row align-items-center'>
                                <div className="col-lg-10" >
                                    <span className={`${style.e_accordion_sub_title}`}>Funds and investments</span>
                                </div>

                            </div> */}
                            <div className='row pt-2'>
                                <div className='col-lg-12'>
                                    <div className={`${style.e_investment_wrapper} `}>
                                        <div className='row gx-2'>
                                            <div className='col-3'>
                                                <h6>Invested Funds</h6>
                                            </div>
                                            <div className='col-1' >
                                                <h6>Allocation</h6>
                                            </div>
                                            <div className='col-1' >
                                                <h6>Amount</h6>
                                            </div>
                                            <div className="col-7">
                                                <div className="d-flex gap-3 align-items-center">

                                                </div>
                                            </div>

                                        </div>
                                        <div className={style.e_min_height} id="e-funds">
                                            {

                                                selectedFunds.map((fundData, index) => {
                                                    const isFirstOccurrence = selectedFunds.findIndex(f => f.index === fundData.index) === index;
                                                    const isAdded = selectedFunds.some((f, i) => f.index === fundData.index && i !== index);
                                                    return (
                                                        <div className='row gx-2 align-items-center'>
                                                            {isFirstOccurrence && <>
                                                                <div className='col-3 position-relative'>
                                                                    {fundData.type?.value !== "NEW_PURCHASE" && <p className='pt-2 mb-0'>{fundData.scheme_name}</p>}
                                                                </div>
                                                                <div className='col-1'>
                                                                    {fundData.type?.value !== "NEW_PURCHASE" && <p className='pt-2 mb-0'>{fundData.allocation !== null ? fundData.allocation : "0"}%</p>}
                                                                </div>
                                                                <div className='col-1'>
                                                                    {fundData.type?.value !== "NEW_PURCHASE" && <p className='pt-2 mb-0'>{fundData.invested_amount ? `₹ ${(fundData.invested_amount)}` : "₹ 0"}</p>}
                                                                </div>
                                                                <div className='col-2 position-relative'>
                                                                    <SelectBox options={actionOptions}
                                                                        value={fundData.type}
                                                                        isSearchable={false}
                                                                        minHeight="38px"
                                                                        isDisabled={fundData.type?.value === "NEW_PURCHASE" ? true : false}
                                                                        placeholder="No Action Required"
                                                                        selectchange={(value) => _handleAction(value, index, fundData)} />
                                                                </div>

                                                            </>}
                                                            <div className={`col-5 ${isFirstOccurrence ? "offset-0  pt-2 " : "offset-7"}`}>
                                                                <div className="d-flex gap-3 align-items-center e-horizontal-scroll pb-0">
                                                                    {(fundData.type?.value === "SWITCH" || fundData.type?.value === "SWITCH_ALL") ?
                                                                        <div ref={(el) => (searchRef.current[index] = el)} className='position-relative' >
                                                                            <Input type='text'
                                                                                placeholder="Search for fund"
                                                                                className='mt-0 p-2 w-300px'
                                                                                value={fundData.switch_name}
                                                                                valueChange={(value) => {
                                                                                    _handleFundSelect(value, index, null);
                                                                                    if (!window.searchTimeouts) {
                                                                                        window.searchTimeouts = {};
                                                                                    }

                                                                                    clearTimeout(window.searchTimeouts[index]);

                                                                                    if (value.length > 0) {
                                                                                        window.searchTimeouts[index] = setTimeout(() => {
                                                                                            _getFunds(value, index);
                                                                                        }, 500); // wait 500ms after typing stops
                                                                                    } else {
                                                                                        setShowDropdown(null);
                                                                                    }

                                                                                }} />
                                                                            {showDropdown === index && (() => {
                                                                                const rect = searchRef.current[index]?.getBoundingClientRect();
                                                                                return rect ? (
                                                                                    <div className="e-cart-search-dropdown"
                                                                                        style={{
                                                                                            position: "fixed",
                                                                                            top: rect.bottom,
                                                                                            left: rect.left,
                                                                                            width: rect.width,
                                                                                            zIndex: 9999,
                                                                                            maxHeight: "200px",
                                                                                            overflowY: "auto",
                                                                                            width: "250px",
                                                                                            wordWrap: "break-word"
                                                                                        }}
                                                                                    >
                                                                                        {fundsList.map((fund, key) => (
                                                                                            <p
                                                                                                key={key}
                                                                                                onClick={() => {
                                                                                                    _getFundDetail(fund, index);
                                                                                                }}
                                                                                                style={{ margin: 0, padding: "8px", cursor: "pointer" }}
                                                                                            >
                                                                                                {fund.scheme_name}
                                                                                            </p>
                                                                                        ))}
                                                                                    </div>
                                                                                ) : null;
                                                                            })()}

                                                                        </div>
                                                                        :
                                                                        fundData.type?.value === "NEW_PURCHASE" ?
                                                                            <>
                                                                                <div ref={(el) => (searchRef.current[index] = el)} className='position-relative' >
                                                                                    <Input type='text'
                                                                                        placeholder="Search for fund"
                                                                                        className='mt-0 p-2 w-300px'
                                                                                        value={fundData.purchase_fund}
                                                                                        valueChange={(value) => {
                                                                                            _handleFundPurchase(value, index, null);
                                                                                            if (!window.searchTimeouts) {
                                                                                                window.searchTimeouts = {};
                                                                                            }

                                                                                            clearTimeout(window.searchTimeouts[index]);

                                                                                            if (value.length > 0) {
                                                                                                window.searchTimeouts[index] = setTimeout(() => {
                                                                                                    _getFunds(value, index);
                                                                                                }, 500); // wait 500ms after typing stops
                                                                                            } else {
                                                                                                setShowDropdown(null);
                                                                                            }

                                                                                        }} />
                                                                                    {showDropdown === index && (() => {
                                                                                        const rect = searchRef.current[index]?.getBoundingClientRect();
                                                                                        return rect ? (
                                                                                            <div className="e-cart-search-dropdown"
                                                                                                style={{
                                                                                                    position: "fixed",
                                                                                                    top: rect.bottom,
                                                                                                    left: rect.left,
                                                                                                    width: rect.width,
                                                                                                    zIndex: 9999,
                                                                                                    maxHeight: "200px",
                                                                                                    overflowY: "auto",
                                                                                                    width: "250px",
                                                                                                    wordWrap: "break-word"
                                                                                                }}
                                                                                            >
                                                                                                {fundsList.map((fund, key) => (
                                                                                                    <p
                                                                                                        key={key}
                                                                                                        onClick={() => {
                                                                                                            setShowDropdown(null);
                                                                                                            _handleFundPurchase(fund.scheme_name, index, fund.scheme_code);
                                                                                                        }}
                                                                                                        style={{ margin: 0, padding: "8px", cursor: "pointer" }}
                                                                                                    >
                                                                                                        {fund.scheme_name}
                                                                                                    </p>
                                                                                                ))}
                                                                                            </div>
                                                                                        ) : null;
                                                                                    })()}
                                                                                </div>

                                                                            </>
                                                                            :
                                                                            null
                                                                    }


                                                                    {
                                                                        fundData.type?.value !== null && <div className='position-relative'>
                                                                            <Input value={fundData.amount}
                                                                                type="number"
                                                                                placeholder="Enter amount"
                                                                                className="p-2 w-180px"
                                                                                disabled={fundData.type?.value === "SWITCH_ALL" || fundData.type?.value === "REDEEM_ALL"}
                                                                                // wrapperClass={`${sipChecked === false ? "opacity-0" : ""}`}
                                                                                valueChange={(input_value) => {
                                                                                    if (fundData.type?.value === "SWITCH_ALL" || fundData.type?.value === "SWITCH" || fundData.type?.value === "REDEEM_ALL" || fundData.type?.value === "REDEMPTION") {
                                                                                        if (input_value <= parseFloat(fundData.invested_amount)) {
                                                                                            _handleAmount(input_value, index)
                                                                                        } else {
                                                                                            setToastMessage({
                                                                                                type: "error",
                                                                                                message: `${fundData.scheme_name}'s ${fundData.type?.label} amount must be less than Invested`
                                                                                            })
                                                                                        }
                                                                                    } else {
                                                                                        _handleAmount(input_value, index)
                                                                                    }
                                                                                }} />
                                                                        </div>
                                                                    }
                                                                    {fundData.type?.value === "SWITCH" && (() => {
                                                                        // Find all indexes of SWITCH funds that share the same "group" (like same original index or mf_id)
                                                                        const sameFundIndexes = selectedFunds
                                                                            .map((f, i) => (f.index === fundData.index ? i : null))
                                                                            .filter(i => i !== null);

                                                                        const lastOccurrenceIndex = sameFundIndexes[sameFundIndexes.length - 1]; // last one in the list
                                                                        const isLast = index === lastOccurrenceIndex; // current is last occurrence
                                                                        const isDuplicate = sameFundIndexes.length > 1; // more than 1 means duplicate exists

                                                                        if (!isDuplicate && isLast) {
                                                                            // Only 1 occurrence → show Add
                                                                            return (
                                                                                <img
                                                                                    src={require('../../assets/images/card/add.svg').default}
                                                                                    alt="Add"
                                                                                    className="cursor-pointer"
                                                                                    onClick={() => _handleAddSwitchInFund(index)}
                                                                                />
                                                                            );
                                                                        }

                                                                        if (isDuplicate && isLast) {
                                                                            // Duplicate exists → only last occurrence shows Delete
                                                                            return (
                                                                                <img
                                                                                    src={require('../../assets/images/modal/delete.svg').default}
                                                                                    alt="Delete"
                                                                                    width={20}
                                                                                    className="cursor-pointer"
                                                                                    onClick={() => _handleDeleteSwitchInFund(index)}
                                                                                />
                                                                            );
                                                                        }

                                                                        return null; // all other occurrences → hide
                                                                    })()}
                                                                    {fundData.type?.value === "NEW_PURCHASE" && <img
                                                                        src={require('../../assets/images/modal/delete.svg').default}
                                                                        alt="Delete"
                                                                        width={20}
                                                                        className="cursor-pointer"
                                                                        onClick={() => _handleDeleteAddedFund(index, fundData.index)}
                                                                    />}
                                                                </div>
                                                            </div>
                                                            {/* {fundData.type?.value === "NEW_PURCHASE" && <div className="col">
                                                                
                                                            </div>} */}
                                                        </div>
                                                    )
                                                })

                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="row pt-4 align-items-center">
                                    <div className="col-8">
                                        <div className="d-flex">
                                            <h6 className="mb-0 me-3">Current value: {props.data.current_value}</h6>
                                            <h6 className="mb-0 me-3">Total returns: {props.data.p_and_l}</h6>
                                            <h6 className="mb-0">Total amount: ₹{_getTotalAmount()}</h6>
                                        </div>
                                    </div>
                                    <div className='col-4 d-flex'>
                                        <SecondaryBtn name="Add new Fund"
                                            className={`w-100 px-2 py-3 me-3 ${!hasRedemption ? "e-disabled" : ""}`}
                                            handleClick={hasRedemption ? _handleAddNew : undefined} />

                                        <PrimaryBtn name="Trigger Rebalance" handleClick={_handleMiniRebalance}
                                            className={_validateForm() === true ? apiLoader === true ? "e-disabled e-btn-loader w-100 py-3" : "w-100 py-3" : "e-disabled py-3 w-100"} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
            </div>

            {
                toastMessage !== null ?
                    <Toast data={toastMessage.message}
                        type={toastMessage.type}
                        id="2"
                        onClose={() => setToastMessage(null)} />
                    :
                    null
            }

        </>
    )
})

export default MiniRebalance;

MiniRebalance.defaultProps = {
}